<div>
  <router-outlet></router-outlet>
  <ngx-sonner-toaster 
    [theme]="themeService.isDark ? 'dark' : 'light'" 
    richColors
    position="top-center" 
  />
</div>